export function toTitleCase(str) {
  if (!str) {
    return "-";
  }
  // remove characters before the last double underscores"__"
  if (str.includes("__")) {
    str = str.replace(/.*__/, "");
  }
  return str
    .split(" ")
    .map((w) => {
      if (w) {
        if (w.indexOf("_") !== -1) {
          return w
            .split("_")
            .map((x) => x[0].toUpperCase() + x.substr(1).toLowerCase())
            .join(" ");
        }
        return w[0].toUpperCase() + w.substr(1).toLowerCase();
      }
      return w;
    })
    .join(" ");
}
